import { useState } from "react";
import Datatable from "../../../components/shared/datatable/Datatable";
import Button from "../../../components/shared/buttons/button";
import useTranslator from "../../../hooks/useTranslator";
import { useGetMixingCartListQuery } from "./mixingCartApi";
import MixingCartModal from "./MixingCartModal";

const MixingCart = () => {
  const { _t } = useTranslator();
  const [page, setPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const { data, isLoading, isFetching } = useGetMixingCartListQuery({ page });

  const handleEdit = (row) => {
    setSelectedRecord(row);
    setShowModal(true);
  };

  const columns = [
    { label: _t("name", "Name"), accessor: "name" },
    { label: _t("empty_weight", "Empty Weight"), accessor: "empty_weight" },
    { label: _t("allowed_weight", "Allowed Weight"), accessor: "allowed_weight" },
    { label: _t("max_tray_space", "Max Tray Space"), accessor: "max_tray_space" },
    {
      label: _t("action", "Action"),
      accessor: "id",
      cell: ({ row }) => (
        <Button
          size="small"
          label={_t("edit", "Edit")}
          onClick={() => handleEdit(row)}
        />
      ),
    },
  ];

  return (
    <div>
      {showModal && (
        <MixingCartModal
          show={showModal}
          setShow={setShowModal}
          record={selectedRecord}
        />
      )}

      <Datatable
        title={_t("mixing_cart", "Mixing Cart")}
        columns={columns}
        tableData={data}
        pagination
        page={page}
        onPageChange={setPage}
        isLoading={isLoading || isFetching}
      />
    </div>
  );
};

export default MixingCart;
